/* DemoPool free tools: live contact finder (curator-finder, label-finder, tool-genre). v3 10.10.2026, 5 free contacts + purchase funnel.
   Showcase rows: GET /api/v1/sample?sku=DP-<prod>-<genre>-all&n=5&open=1 -> 5 full emails per product+genre (fixed for 30 days on the ND side,
   CORS = our domains only, 60 requests/day per IP). Cached in localStorage 12 h per sku to spare the quota.
   Fallback (open=1 fails, limit hit, timeout): masked rows from the same endpoint without open=1, re-masked here, exactly as v2.
   Label finder also loads masked n=<data-fetch> rows so the country filter has something to filter (open rows come first).
   Below the rows: server-rendered blurred placeholder rows (never real data) + gate card + sticky CTA. JS only updates their text/links on genre change.
   Root: [data-finder] data-prod data-kind=curators|labels data-show data-fetch data-genre data-genre-name data-count data-rows data-price data-col data-tool
   Inside: [data-gsel] genre select (options carry data-name/data-count/data-rows/data-price), [data-country] select (labels), [data-n] big number,
   [data-gl] label over it, [data-results] list, [data-status], [data-tinfo] tooltip.
   Funnel (same .tool): [data-lock] blurred block, [data-gate] card ([data-gate-n] [data-gate-g] [data-gate-p] [data-gate-cta] [data-gate-t]),
   [data-sticky] bar ([data-sticky-n]). Analytics: dataLayer tool_cta + clarity event, nothing else.
   20.10.2026: gate + sticky carry data-buy (snippets/dp-tool-gate); genre changes set data-buy-genre, assets/dp-tool-buy.js adds the matched file to the cart. */
(() => {
  const API = 'https://ninja-digger.vercel.app/api/v1/sample';
  const TTL = 36e5, OTTL = 432e5, TIMEOUT = 8000;
  const esc = t => String(t == null ? '' : t).replace(/[&<>"']/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  const cache = s => ({
    get(k, ttl) { try { const v = JSON.parse(s().getItem(k) || 'null'); return v && Date.now() - v.t < ttl ? v.rows : null; } catch (_) { return null; } },
    set(k, rows) { try { s().setItem(k, JSON.stringify({ t: Date.now(), rows })); } catch (_) {} }
  });
  const sess = cache(() => sessionStorage), loc = cache(() => localStorage);
  // masked mode: a full address must never reach the page, re-mask anything that is not masked yet
  const mask = e => {
    e = String(e || '').trim(); if (!e) return '';
    if (e.includes('*')) return e;
    const at = e.lastIndexOf('@'); return at < 1 ? '' : e.charAt(0) + '***' + e.slice(at);
  };
  const isMail = e => /^[^\s@*]+@[^\s@*]+\.[^\s@*]+$/.test(String(e || ''));
  const fmt = n => { try { return (+n).toLocaleString('en-US'); } catch (_) { return String(n); } };
  const big = n => { n = +n; return !n ? '' : n >= 1e6 ? (n / 1e6).toFixed(1).replace(/\.0$/, '') + 'M' : n >= 1e4 ? Math.round(n / 1e3) + 'k' : n >= 1e3 ? (n / 1e3).toFixed(1).replace(/\.0$/, '') + 'k' : String(n); };
  const nice = n => /^[a-z0-9]+([-_][a-z0-9]+)+$/.test(n || '') ? n.split(/[-_]/).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') : (n || 'Unnamed');
  const flag = cc => cc && /^[A-Za-z]{2}$/.test(cc) ? String.fromCodePoint(...[...cc.toUpperCase()].map(c => 127397 + c.charCodeAt(0))) : '';
  let dn = null; try { dn = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (_) {}
  const cname = cc => { try { return (dn && dn.of(cc.toUpperCase())) || cc; } catch (_) { return cc; } };
  const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const when = d => {
    const t = Date.parse(d); if (!t) return '';
    const x = new Date(t), days = Math.round((Date.now() - t) / 864e5);
    return days < 60 ? (days < 7 ? 'this week' : days < 14 ? 'last week' : Math.round(days / 7) + ' weeks ago') : MON[x.getUTCMonth()] + ' ' + x.getUTCFullYear();
  };
  // masked rows send keys (main_contact), open rows send labels (Main contact)
  const DEMO = { main_contact: 'Main contact', demo_inbox: 'Demo inbox', demo: 'Demo inbox', demo_email: 'Demo inbox', 'demo email': 'Demo inbox', form: 'Submission form', 'main contact': 'Main contact', 'demo inbox': 'Demo inbox', 'demo form': 'Submission form', 'submission form': 'Submission form' };
  const INBOX = { personal: 'Personal', info: 'Info inbox', main: 'Main inbox', demo: 'Demo inbox', booking: 'Booking', promo: 'Promo inbox' };
  const ini = n => (String(n).match(/[A-Za-z0-9]/g) || ['#']).slice(0, 2).join('').toUpperCase();
  const hue = n => { let h = 0; for (const c of String(n)) h = (h * 31 + c.charCodeAt(0)) >>> 0; return [18, 28, 340, 265, 150, 200, 45][h % 7]; };
  const LOCK = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="10" rx="2.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  const COPY = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="8.5" y="8.5" width="11" height="11" rx="2.5"/><path d="M15.5 8.5V6.5a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2"/></svg>';
  const TICK = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  const track = (tool, cta, genre) => {
    try { (window.dpEvent || ((n, p) => (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: n }, p))))('tool_cta', { tool, cta, genre }); } catch (_) {}
    try { window.clarity && window.clarity('event', 'tool_cta_' + cta); } catch (_) {}
  };

  // one row per curator / label: the source sometimes lists one name with several inboxes
  const dedupe = rows => { const seen = new Set(); return (rows || []).filter(r => { const k = String(r.name || r.email || '').toLowerCase().trim(); if (!k || seen.has(k)) return false; seen.add(k); return true; }); };

  // Our own stored logo/avatar (ND image_url, a cdn.shopify.com 256px WebP): the 40px tile asks the CDN for width=96. The box is fixed-size, so
  // no layout shift; a failed load removes the <img> and the cassette placeholder (CSS) stays (error listener on the list).
  const pic = u => /^https:\/\/cdn\.shopify\.com\/.+\.webp(\?|$)/i.test(u || '') ? '<img src="' + esc(u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=96&height=96&crop=center') + '" alt="" width="40" height="40" loading="lazy" decoding="async" referrerpolicy="no-referrer">' : '';
  const row = (r, kind) => {
    const name = nice(r.name), meta = [];
    if (kind === 'labels' && r.country) meta.push(flag(r.country) + ' ' + esc(cname(r.country)));
    if (big(r.audience)) meta.push(big(r.audience) + ' followers');
    if (kind === 'curators' && +r.playlists) meta.push((+r.playlists) + (+r.playlists === 1 ? ' playlist' : ' playlists'));
    if (kind === 'labels') { const lr = when(r.last_release); if (lr) meta.push('Released ' + esc(lr)); }
    const g = (r.genres || []).slice(0, 2).map(esc).join(', ');
    const open = !!r._open && isMail(r.email);
    const m = open ? r.email : mask(r.email);
    const tag = kind === 'labels' ? (DEMO[String(r.demo || '').toLowerCase()] || '') : (INBOX[r.inbox] || '');
    const mail = !m ? '' : open
      ? '<div class="ff__mail ff__mail--open"><p class="ff__addr" translate="no">' + esc(m).replace('@', '@<wbr>') + '</p>' + (tag ? '<small>' + esc(tag) + '</small>' : '') +
        '<button type="button" class="ff__copy" data-copy="' + esc(m) + '" aria-label="Copy email ' + esc(m) + '">' + COPY + '<span data-copy-t>Copy</span></button></div>'
      : '<p class="ff__mail">' + LOCK + '<span class="ff__addr"><span class="visually-hidden">Email, masked in the preview: </span>' + esc(m) + '</span>' + (tag ? '<small>' + esc(tag) + '</small>' : '') + '</p>';
    return '<li class="ff__row' + (open ? ' ff__row--open' : '') + '">' +
      '<span class="ff__av" style="--h:' + hue(name) + '" aria-hidden="true">' + esc(ini(name)) + pic(r.image_url) + '</span>' +
      '<div class="ff__id"><p class="ff__name">' + esc(name) + '</p>' +
      '<p class="ff__meta">' + meta.map(x => '<span>' + x + '</span>').join('') + (g ? '<span class="ff__g">' + g + '</span>' : '') + '</p></div>' +
      mail + '</li>';
  };
  const skel = n => Array.from({ length: n }, () => '<li class="ff__row ff__row--open ff__row--sk" aria-hidden="true"><span class="ff__av"></span><div class="ff__id"><i></i><i></i></div><p class="ff__mail"><i></i></p></li>').join('');

  const req = (url, signal) => fetch(url, { signal, credentials: 'omit' }).then(r => r.ok ? r.json() : Promise.reject(new Error('http ' + r.status)));
  const timed = url => {
    const ac = 'AbortController' in window ? new AbortController() : null;
    const timer = setTimeout(() => ac && ac.abort(), TIMEOUT);
    return req(url, ac ? ac.signal : undefined).then(j => { clearTimeout(timer); return j; }, e => { clearTimeout(timer); throw e; });
  };
  // masked rows (fallback + country filter)
  const getMasked = (sku, n) => {
    const key = 'dpf1:' + sku + ':' + n, hit = sess.get(key, TTL);
    if (hit) return Promise.resolve(hit);
    return timed(API + '?sku=' + encodeURIComponent(sku) + '&n=' + n)
      .then(j => { const rows = (j.rows || []).map(r => Object.assign({}, r, { email: mask(r.email), _open: false })); sess.set(key, rows); return rows; });
  };
  // showcase rows with full emails; anything that is not a clean address is treated as a failure -> fallback
  const getOpen = sku => {
    const key = 'dpf2o:' + sku, hit = loc.get(key, OTTL);
    if (hit) return Promise.resolve(hit);
    return timed(API + '?sku=' + encodeURIComponent(sku) + '&n=5&open=1')
      .then(j => {
        const rows = (j.rows || []).filter(r => isMail(r.email)).slice(0, 5).map(r => Object.assign({}, r, { _open: true }));
        if (!j.open || !rows.length) throw new Error('not open');
        loc.set(key, rows); return rows;
      });
  };

  const copyText = t => {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t);
    return new Promise((ok, no) => {
      const a = document.createElement('textarea'); a.value = t; a.setAttribute('readonly', ''); a.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
      document.body.appendChild(a); a.select();
      try { document.execCommand('copy') ? ok() : no(); } catch (e) { no(e); } finally { a.remove(); }
    });
  };

  const tip = ti => {
    const b = ti.querySelector('button'); if (!b) return;
    const set = o => { ti.classList.toggle('is-open', o); b.setAttribute('aria-expanded', o ? 'true' : 'false'); };
    b.addEventListener('click', e => { e.stopPropagation(); set(!ti.classList.contains('is-open')); });
    document.addEventListener('click', e => { if (!ti.contains(e.target)) set(false); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') set(false); });
  };

  const init = root => {
    const d = root.dataset, kind = d.kind || 'labels', prod = d.prod, show = +d.show || 5, want = +d.fetch || show;
    const noun = kind === 'labels' ? 'labels' : 'curators', tool = d.tool || 'finder';
    const list = root.querySelector('[data-results]'), status = root.querySelector('[data-status]');
    list.addEventListener('error', e => { if (e.target && e.target.tagName === 'IMG') e.target.remove(); }, true);
    const gsel = root.querySelector('[data-gsel]'), csel = root.querySelector('[data-country]');
    const nEl = root.querySelector('[data-n]'), gl = root.querySelector('[data-gl]');
    const scope = root.closest('.tool') || document;
    const lock = scope.querySelector('[data-lock]'), gate = scope.querySelector('[data-gate]'), sticky = scope.querySelector('[data-sticky]');
    const q = s => scope.querySelector(s);
    const gN = q('[data-gate-n]'), gG = q('[data-gate-g]'), gP = q('[data-gate-p]'), gCta = q('[data-gate-cta]'), gT = q('[data-gate-t]'), sN = q('[data-sticky-n]');
    let genre = d.genre || 'all', openRows = [], maskRows = [], free = show, req = 0;
    // .dp-flow is isolation:isolate, so a fixed bar inside it sits under the footer near the page end (20.10.2026): move it to <body>
    if (sticky) { const w = sticky.closest('.ff__stwrap') || sticky; if (w.parentElement !== document.body) document.body.appendChild(w); }
    root.querySelectorAll('[data-tinfo]').forEach(tip);

    const opt = s => gsel ? [...gsel.options].find(o => o.value === s) : null;
    const gname = () => { if (genre === 'all') return ''; const o = opt(genre); return o ? o.dataset.name : (d.genreName || ''); };
    const gdata = k => { const o = opt(genre); return o ? (o.dataset[k] || '') : (d[k] || ''); };
    const href = () => d.col + (genre !== 'all' ? '?genre=' + encodeURIComponent(genre) : '') + '#pick'; // no utm: GA4 select_content (snippets/dp-ga4)

    const syncHead = () => {
      const n = gdata('count'), g = gname(), rows = +String(gdata('rows')).replace(/,/g, '') || 0, price = gdata('price');
      if (nEl && n) nEl.textContent = n;
      if (gl) gl.textContent = g ? g + ' ' + noun : (noun === 'labels' ? 'Labels' : 'Curators') + ' in the list';
      const more = Math.max(rows - free, 0);
      // Country = US + a genre with a US file (owner 20.10): the gate sells the US slice, no count until facts has US slices
      const usm = csel && csel.value === 'US' && g && window.dpBuy ? window.dpBuy.pick(prod, genre, 'US') : null, us = !!(usm && usm.kind === 'country');
      const gx = us ? 'US ' + g + ' ' : (g ? g + ' ' : '');
      if (gN) gN.textContent = us ? 'All' + (usm.count ? ' ' + usm.count : '') : more ? '+' + fmt(more) + ' more' : 'All';
      if (gG) gG.textContent = gx + noun;
      if (gT) gT.textContent = 'Get all ' + gx + noun;
      if (gP && price) gP.textContent = price;
      if (sN) sN.textContent = us ? gx + noun : n || sN.textContent;
      [gCta, sticky].forEach(a => { if (a) a.href = href(); });
      // add-to-cart target (assets/dp-tool-buy.js re-picks the variant and price on this attribute)
      [gate, sticky && sticky.closest('[data-buy]')].forEach(b => { if (b && b.hasAttribute('data-buy')) { b.setAttribute('data-buy-genre', genre); b.setAttribute('data-buy-country', us ? 'US' : ''); } });
    };
    const shown = () => {
      const c = csel ? csel.value : 'all';
      if (c === 'all') return (openRows.length ? openRows : maskRows).slice(0, show);
      const o = openRows.filter(r => r.country === c), names = new Set(o.map(r => String(r.name).toLowerCase().trim()));
      return o.concat(maskRows.filter(r => r.country === c && !names.has(String(r.name).toLowerCase().trim()))).slice(0, show);
    };
    const fillCountries = () => {
      if (!csel) return;
      const n = {}; dedupe(openRows.concat(maskRows)).forEach(r => { if (r.country) n[r.country] = (n[r.country] || 0) + 1; });
      const opts = Object.keys(n).sort((a, b) => n[b] - n[a] || cname(a).localeCompare(cname(b)));
      csel.innerHTML = '<option value="all">Any country</option>' + opts.map(c => '<option value="' + esc(c) + '">' + esc(cname(c)) + '</option>').join('');
      csel.disabled = !opts.length;
    };
    const paint = () => {
      const c = csel ? csel.value : 'all', pick = shown();
      root.setAttribute('aria-busy', 'false');
      root.classList.toggle('is-masked', !openRows.length);
      if (!pick.length) { list.innerHTML = ''; status.innerHTML = '<p class="ff__msg">No examples for this ' + (c !== 'all' ? 'country' : 'genre') + ' in the preview yet. Try another one.</p>'; return; }
      list.innerHTML = pick.map(r => row(r, kind)).join(''); list.removeAttribute('data-ssr');
      const nOpen = pick.filter(r => r._open).length;
      status.innerHTML = '<p class="visually-hidden">' + pick.length + ' examples loaded' + (nOpen ? ', ' + nOpen + ' with full email' : '') + '.</p>';
    };
    const fail = () => {
      root.setAttribute('aria-busy', 'false');
      if (list.hasAttribute('data-ssr') && genre === 'all' && list.querySelector('.ff__row:not(.ff__row--sk)')) return; // keep the server rows
      list.innerHTML = '';
      status.innerHTML = '<div class="ff__msg ff__msg--err"><p>Examples did not load. The list itself is fine.</p><button type="button" class="tf__chip" data-retry>Try again</button></div>';
      status.querySelector('[data-retry]').addEventListener('click', load);
    };
    function load() {
      const id = ++req, sku = 'DP-' + prod + '-' + genre + '-all';
      root.setAttribute('aria-busy', 'true'); status.innerHTML = '<p class="visually-hidden">Loading examples</p>';
      // 30.10: server-rendered showcase rows (data-ssr, snippets/dp-sample-rows) stay on screen for All genres until the live rows arrive
      const ssr = list.hasAttribute('data-ssr') && genre === 'all' && (!csel || csel.value === 'all');
      if (!ssr) list.innerHTML = skel(show); openRows = []; maskRows = [];
      const extra = csel && want > show ? getMasked(sku, want).catch(() => []) : Promise.resolve([]);
      getOpen(sku)
        .then(o => extra.then(m => [o, m]))
        .catch(() => getMasked(sku, want).then(m => [[], m]))
        .then(([o, m]) => { if (id !== req) return; openRows = dedupe(o); maskRows = dedupe(m); fillCountries(); paint(); })
        .catch(() => { if (id === req) fail(); });
    }
    const pickGenre = (s, push) => {
      if (gsel && !opt(s)) s = 'all';
      genre = s;
      if (gsel) gsel.value = s;
      if (csel) csel.value = 'all';
      if (push && gsel) { try { const u = new URL(location.href); s === 'all' ? u.searchParams.delete('genre') : u.searchParams.set('genre', s); history.replaceState(null, '', u); } catch (_) {} }
      syncHead(); load();
    };

    list.addEventListener('click', e => {
      const b = e.target.closest('[data-copy]'); if (!b) return;
      const t = b.querySelector('[data-copy-t]'), mail = b.dataset.copy;
      copyText(mail).then(() => {
        b.classList.add('is-done'); b.querySelector('svg').outerHTML = TICK; if (t) t.textContent = 'Copied';
        b.setAttribute('aria-label', 'Copied ' + mail);
        clearTimeout(b._t); b._t = setTimeout(() => { b.classList.remove('is-done'); b.querySelector('svg').outerHTML = COPY; if (t) t.textContent = 'Copy'; b.setAttribute('aria-label', 'Copy email ' + mail); }, 2000);
      }, () => { if (t) t.textContent = 'Select it'; });
      track(tool, 'copy', genre);
    });
    if (gCta) gCta.addEventListener('click', () => track(tool, 'gate', genre));
    if (sticky) sticky.addEventListener('click', () => track(tool, 'sticky', genre));

    // sticky CTA: on once the blurred block has been reached, off while the gate card is on screen
    if (sticky && lock && gate && 'IntersectionObserver' in window) {
      let reached = false, gateOn = false;
      const html = document.documentElement;
      const set = () => {
        const on = reached && !gateOn;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        sticky.tabIndex = on ? 0 : -1;
        html.classList.toggle('ff-sticky-pad', on);
      };
      new IntersectionObserver(es => es.forEach(e => {
        const vh = (e.rootBounds && e.rootBounds.height) || window.innerHeight;
        reached = e.isIntersecting || e.boundingClientRect.top < vh; set();
      }), { rootMargin: '0px 0px -30% 0px' }).observe(lock);
      new IntersectionObserver(es => es.forEach(e => { gateOn = e.isIntersecting; set(); }), { threshold: 0.35 }).observe(gate);
    }

    if (gsel) gsel.addEventListener('change', () => pickGenre(gsel.value, true));
    if (csel) csel.addEventListener('change', () => { syncHead(); paint(); });
    let start = genre;
    if (gsel) { try { const s = new URL(location.href).searchParams.get('genre'); if (s && opt(s)) start = s; } catch (_) {} }
    pickGenre(start, false);
  };

  const boot = () => document.querySelectorAll('[data-finder]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  if (typeof module !== 'undefined') module.exports = { mask, big, dedupe, when, nice, row, isMail, fmt };
})();
